import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";

export const PaletizacionesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getPaletizaciones = async () => {
        try {
            setCargando(true);
            const response = await api.get("paletizacion/paletizaciones_turno_actual");
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearPaletizacion = async () => {
        try {
            setCargando(true);
            const response = await api.post("paletizacion");
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deletePaletizacion = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`paletizacion/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const cerrarPaletizacion = async () => {
        try {
            setCargando(true);
            const response = await api.post("paletizacion/cerrar_paletizacion");
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getPaletizaciones,
        crearPaletizacion,
        deletePaletizacion,
        cerrarPaletizacion,

        cargando,
    };
};
